<template>
  <div class="content has-text-centered">
    <!-- <holiday-bar></holiday-bar> -->
    <div class="bg"><img src="../../assets/img/eurotrader_logo_rgb_purple.svg" /></div>

    <!-- div class="notice-top">
      <span class="has-text-primary has-text-weight-bold">Do you want to transform your trading?</span>
      <router-link
        to="/en/transfer-reset-password"
        class="has-text-white"
      >Reset your password to transfer your account.</router-link>
    </div -->
    <br />
    <br />
    <br />
    <!-- <div class="notification is-primary" v-show="error">{{error}}</div> -->
    <div class="columns is-vcentered is-centered">
      <div class="column is-6">
        <div class="box">
          <!-- <img src="../../assets/img/eurotrader-logo.svg" /> -->
          <!-- <h1 class="is-title is-bold">{{ $t('login_to_your_account').tTitle() }}</h1> -->
          <!-- title: login to your account -->
          <h1 v-html="$t('login_to_your_account').tUpper()"></h1>

          <!-- <div v-show="error" style="color:red; word-wrap:break-word;">{{ error }}</div> -->
          <form v-on:submit.prevent="validateCaptcha()">
            <p class="control">
              <label class="label">{{ $t('email').tTitle() }}*</label>
              <input
                v-model="data.body.email"
                class="ete-input input"
                type="text"
                placeholder="Email"
              />
            </p>
            <p class="control">
              <label class="label">{{ $t('password').tTitle() }}*</label>
              <input
                v-model="data.body.password"
                class="ete-input input"
                type="password"
                placeholder="Password"
              />
            </p>

            <p class="control">
              <input
                type="checkbox"
                id="chk-rem-me"
                name="chk-rem-me"
              />&nbsp;&nbsp;
              <label
                for="chk-rem-me"
                id="lbl-rem"
                class="label"
                style="float: left"
              >{{$t('remember_me')}}</label>
              <router-link
                style="float: right"
                id="lnk-forgot-pass"
                class="forgotPassword"
                :to="'/' + (Language || 'en') + '/forgot-password'"
              >{{
                $t('forgot_password_q').tTitle()
              }}</router-link>
            </p>

            <button
              type="submit"
              id="btn-ete-submit"
              class="button is-primary login"
            >{{ $t('login').tUpper() }}</button>

            <hr />

            <h4
              style="font: normal normal 900 23px/20px Roboto"
              class="is-title is-bold"
            >{{ $t('not_registered_with_question').tUpper() }}</h4>
            <!-- Open Live and Demo account buttons -->
            <div class="columns regButtons">
              <div class="column">
                <router-link
                  id="btn-ete-open-live"
                  class="button is-primary reg"
                  :to="'/' + (Language || 'en') + '/register/live'"
                >{{
                  $t('open_live_account').tUpper()
                }}</router-link>
              </div>
              <div class="column">
                <router-link
                  id="btn-ete-open-demo"
                  class="button is-secondary-outline reg"
                  :to="'/' + (Language || 'en') + '/register/demo'"
                >{{
                  $t('open_demo_account').tUpper()
                }}</router-link>
              </div>
            </div>
            <hr style="display: none" />
            <div id="vertical-space"></div>
            <div class="is-center">
              <!-- span class="select is-small lang">
                <select v-on:change="changeLang">
                  <option selected value="en">ENGLISH</option>
                  <option value="tr">TURKISH</option>
                  <option value="th">THAI</option>
                </select>
              </span-->
              <div style="float:left">
                <span id="spn-your-data">{{$t('risk_sentence')}}</span>
                <a
                  style="color: white; font: normal normal 550 12px/14px Roboto"
                  class="is-small"
                  href="https://eurotrader-com.s3.eu-west-2.amazonaws.com/legal-documents/Privacy%20Policy.pdf"
                  target="_blank"
                >{{ $t('privacy_policy').tTitle() }}</a>
              </div>
              <div style="float:right">
                <span class="select is-small lang">
                  <language />
                </span>
              </div>
            </div>
            <div class="is-clearfix"></div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
// import {service} from '../../app'
import config from '../../config'
import { Base64 } from 'js-base64'
import Language from '../../components/Language'
// import HolidayBar from '../../components/HolidayBar.vue'

export default {
  components: {
    Language,
    // HolidayBar,
  },
  data() {
    return {
      data: {
        body: {
          email: null,
          password: null,
        },
      },
      error: null,
      recaptchaToken: null
    }
  },
  computed: {
    websiteURL() {
      return config.URL.website
    },
    ...mapGetters({
      Language: 'language/code',
    }),
  },
  mounted() {
    this.$bus.$emit('ChangeHeadings', 'Login to your account | Eurotrader', null)
    if (this.$auth.check()) {
      this.$router.push('/' + (this.Language || 'en') + '/' + config.defaultURL)
    } else {
      this.$bus.$emit('LiveFeedClose')
    }

    setTimeout(() => {
      if (this.$auth.check()) {
        this.$router.push('/' + (this.Language || 'en') + '/' + config.defaultURL)
      }
    }, 500)
  },
  methods: {
    changeLang(event) {
      this.$bus.$emit('ChangeLang', event)
    },
    validateCaptcha() {
      this.$recaptchaLoaded()
      this.recaptchaToken = this.$recaptcha('login')

      this.recaptchaToken.then(value => {
        this.login(value)
      }).catch(err => {
        console.log(err)
      })
    },
    login(token) {
      this.$auth
        .login({
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Basic ' + Base64.encode(this.data.body.email + ':' + this.data.body.password + ':' + token),
          },
          redirect: {
            name: 'Quick menu | english',
          },
          staySignedIn: true,
        })
        .then(
          res => {
            // Success
            this['menu/reset']()
            setTimeout(() => {
              try {
                var redirectUrl = '/' + (this.Language || 'en') + '/trading-account/list'
                console.log('redirect to ', redirectUrl)
                this.$router.push(redirectUrl)
              } catch (e) {
                console.log(e)
              }
            }, 1000)
            this.$auth.fetch().then(
              res => {
                // Success
                this.$bus.$emit('LiveFeedConnect')
              },
              err => {
                // Failure
              }
            )

          },
          err => {
            // Error
            console.log('Error', err)
            if (err.response) {
              // this.$toasted.error(err.response.data.detail + '<span class="error-id">' + err.response.data.id + '</span>', {duration: 20000})
              this.$toasted.error(err.response.data.detail, { duration: 20000 })
              this.error = err.response.data
              this.$store.state.token = null
            }
          }
        )
    },
    ...mapActions(['menu/reset']),
  },

  filters: {
    json: function (value) {
      return value
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~bulma/sass/utilities/initial-variables';
@import '../../assets/css/variables';

.bg {
  width: 100%;
  position: fixed;
  height: 100%;
  left: 0;
  top: 0;
  z-index: -1;
  background-image: url('../../assets/img/bg-et-clientarea1.png');
  background-size: cover;
  > img {
    position: absolute;
    top: 27px;
    // added for holidays
    // top: 40px;
    left: 42px;
    width: 176px;
    height: 27px;
  }
}

.box {
  * {
    font-family: 'Roboto', sans-serif;
  }
  padding: 40px 40px;
  border-top-left-radius: 0px;
  border-top-right-radius: 0px;
  border-bottom-right-radius: 30px;
  border-bottom-left-radius: 0px;
  background: #6826f4 0% 0% no-repeat padding-box;
  box-shadow: 5px 5px 20px #0000001a;

  background-color: #6826f4;
  opacity: 1;
  > img {
    width: 300px;
  }
  h1 {
    color: #fff;
    margin: 30px 0 40px 0;

    font-size: 44px;
    font-weight: 900;
    line-height: 0.85;

    &::first-line {
      color: #e04ef8;
    }

    @media screen and (max-width: $tablet) {
      margin: 15px 0 10px;
    }
  }

  form {
    padding: 0 20px;
    h4 {
      color: #fff;
      font-size: 18px;
    }
    a:hover {
      color: #fff;
    }
    a.forgotPassword {
      float: left;
      margin: -10px 0 20px;
      font-size: 14px;
    }
    label {
      text-align: left;
      font-size: 16px;
      color: #fff;
      height: 26px;
      font-weight: 300;
      margin-bottom: 0;
    }
    input.input {
      height: 46px;
      font-size: 18px;
      font-weight: 300;
      margin-bottom: 15px;
    }
    .columns.regButtons {
      margin-bottom: -10px;
    }
    .button.login,
    .button.reg {
      font-family: $family-condensed;
      font-weight: 700;
      width: 100%;
      &.is-black {
        background-color: #000;
        border: 1px solid #f0f0f0;
      }
    }
    .select.lang {
      select {
        background-color: #6826f4;
        color: #fff;
        border: none;
        outline: none;
      }
      &:not(.is-multiple)::after {
        top: 50%;
        border-color: #fff;
      }
    }
    a.is-small {
      font-size: 12px;
    }
  }

  #chk-rem-me {
    width: 18px;
    height: 18px;
    background: #f5f5f5 0% 0% no-repeat padding-box;
    border: 6px;
    border-radius: 3px;
    opacity: 1;
    float: left;
    margin: -7px 10px 20px 0px;
    &:focus {
      outline: none;
    }
  }

  #lbl-rem {
    height: 11px;
    font-size: 12px;
    font-weight: 300;
    margin: -6px 0 20px;
    user-select: none;
  }

  #lnk-forgot-pass {
    height: 11px;
    font-size: 12px;
    font-weight: 300;
    color: #ffffff;
    margin: -6px 0 20px;
  }

  #btn-ete-submit {
    font-size: 12px;
    font-weight: 600;
    max-width: 152px;
    height: 40px;
    background-color: #3bed83;
    border-radius: 23px;
    color: #10182a;
  }

  #btn-ete-open-live {
    background-color: #e04ef8;
    border-radius: 23px;
    height: 40px;
    font-size: 12px;
    font-weight: 600;
  }

  #btn-ete-open-demo {
    background: #6826f4;
    border: 1px solid #e04ef8;
    color: white;
    border-radius: 23px;
    height: 40px;
    font-size: 12px;
    font-weight: 600;
  }

  #spn-your-data {
    font: normal normal 300 12px/14px Roboto;
    letter-spacing: 0px;
    color: #ffffff;
  }

  #vertical-space {
    margin: 0 0 38px 0;
  }
}

.notice-top {
  position: fixed;
  top: 0;
  left: 0;
  padding: 20px 0;
  width: 100%;
  background-color: $secondary;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// Login.vue?14c79758